/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_LanggraphInputs */

const en_svchip_langgraph = /** @type {(inputs: Svchip_LanggraphInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LangGraph`)
};

const ar_svchip_langgraph = /** @type {(inputs: Svchip_LanggraphInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لانغراف`)
};

const bn_svchip_langgraph = /** @type {(inputs: Svchip_LanggraphInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LangGraph`)
};

const de_svchip_langgraph = /** @type {(inputs: Svchip_LanggraphInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LangGraph`)
};

const es_svchip_langgraph = /** @type {(inputs: Svchip_LanggraphInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LangGraph`)
};

const fr_svchip_langgraph = /** @type {(inputs: Svchip_LanggraphInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LangGraph`)
};

const pt_svchip_langgraph = /** @type {(inputs: Svchip_LanggraphInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LangGraph`)
};

const zh_svchip_langgraph = /** @type {(inputs: Svchip_LanggraphInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`郎图`)
};

const tr_svchip_langgraph = /** @type {(inputs: Svchip_LanggraphInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LangGraph`)
};

const ru_svchip_langgraph = /** @type {(inputs: Svchip_LanggraphInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ЛанГраф`)
};

const pl_svchip_langgraph = /** @type {(inputs: Svchip_LanggraphInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`LangGraph`)
};

/**
* | output |
* | --- |
* | "LangGraph" |
*
* @param {Svchip_LanggraphInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_langgraph = /** @type {((inputs?: Svchip_LanggraphInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_LanggraphInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_langgraph(inputs)
	if (locale === "bn") return bn_svchip_langgraph(inputs)
	if (locale === "de") return de_svchip_langgraph(inputs)
	if (locale === "es") return es_svchip_langgraph(inputs)
	if (locale === "fr") return fr_svchip_langgraph(inputs)
	if (locale === "pt") return pt_svchip_langgraph(inputs)
	if (locale === "zh") return zh_svchip_langgraph(inputs)
	if (locale === "tr") return tr_svchip_langgraph(inputs)
	if (locale === "ru") return ru_svchip_langgraph(inputs)
	if (locale === "pl") return pl_svchip_langgraph(inputs)
	return en_svchip_langgraph(inputs)
});